import React from 'react';
import '../../styles/horeca/horecaproductbanner.css'


const HorecaProductsBanner = () => {

    return(
        <div className='horecaproductsbanner'>
            <h1 style={{fontWeight:'600' ,width:'50%'}}>Explore Our Premium Food Products</h1>
            <p style={{color:'white'}}>Sourced globally, delivered with care to elevate your culinary creations.</p>

        </div>
        
    );



}

export default HorecaProductsBanner;



